import { render, staticRenderFns } from "./NonDrinkResults.vue?vue&type=template&id=48788706&scoped=true&"
import script from "./NonDrinkResults.vue?vue&type=script&lang=ts&"
export * from "./NonDrinkResults.vue?vue&type=script&lang=ts&"
import style0 from "./NonDrinkResults.vue?vue&type=style&index=0&id=48788706&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48788706",
  null
  
)

export default component.exports